import { App as AntdApp } from 'antd'
import { useEffect } from 'react'
import { setToastInstance } from '@/utils/toast'

/** 把 antd 上下文 message 实例(继承 ConfigProvider 主题)注入 @/utils/toast 门面;渲染 null。 */
export function MessageBridge() {
  const { message } = AntdApp.useApp()
  useEffect(() => {
    setToastInstance(message)
  }, [message])
  return null
}
